import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BottomNav } from '../components/BottomNav';
import { OrderCard } from '../components/OrderCard';
import { orders } from '../data/mockData';
export function Orders() {
  const [activeTab, setActiveTab] = useState<'pending' | 'processing' | 'completed'>('pending');
  const filteredOrders = orders.filter(o => o.status === activeTab);
  const tabs = [{
    id: 'pending' as const,
    label: 'Pending',
    count: orders.filter(o => o.status === 'pending').length
  }, {
    id: 'processing' as const,
    label: 'Processing',
    count: orders.filter(o => o.status === 'processing').length
  }, {
    id: 'completed' as const,
    label: 'Completed',
    count: orders.filter(o => o.status === 'completed').length
  }];
  return <div className="min-h-screen pb-24" data-id="element-267">
      <div className="max-w-md mx-auto" data-id="element-268">
        {/* Header */}
        <div className="p-5 pt-8" data-id="element-269">
          <h1 className="text-white text-2xl font-bold tracking-tight" data-id="element-270">
            Orders
          </h1>
        </div>

        {/* Pill Tabs */}
        <div className="px-5 mb-6" data-id="element-271">
          <div className="glass-card p-1 flex" data-id="element-272">
            {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex-1 py-2.5 rounded-xl font-semibold text-sm transition-all duration-300 relative z-10 ${activeTab === tab.id ? 'text-[#0A0E1A]' : 'text-[#64748B] hover:text-white'}`} data-id="element-273">
                {activeTab === tab.id && <motion.div layoutId="orderTab" className="absolute inset-0 bg-[#00D68F] rounded-xl -z-10 shadow-[0_0_15px_rgba(0,214,143,0.2)]" transition={{
              type: 'spring',
              stiffness: 400,
              damping: 30
            }} data-id="element-274" />}
                {tab.label}{' '}
                <span className="opacity-60 ml-1" data-id="element-275">({tab.count})</span>
              </button>)}
          </div>
        </div>

        {/* Orders List */}
        <div className="px-5" data-id="element-276">
          <AnimatePresence mode="wait" data-id="element-277">
            <motion.div key={activeTab} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.2
          }} className="space-y-3" data-id="element-278">
              {filteredOrders.length > 0 ? filteredOrders.map((order, index) => <motion.div key={order.id} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: index * 0.05
            }} data-id="element-279">
                    <OrderCard order={order} data-id="element-280" />
                  </motion.div>) : <div className="text-center py-16 glass-card" data-id="element-281">
                  <p className="text-[#64748B] font-medium" data-id="element-282">
                    No {activeTab} orders found
                  </p>
                </div>}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>

      <BottomNav data-id="element-283" />
    </div>;
}